export default {
  selectPreset: 'Vybrať predvoľbu',
  resetPreset: 'Resetovať zmeny predvoľby',
};
